export enum BillingEventTypeEnum {
  // Records
  RENTAL_RESERVATION_ACCEPTED = 'rental_reservation_accepted',
  RENTAL_RESERVATION_CANCELLED = 'rental_reservation_cancelled',
  RENTAL_RESERVATION_DELETED = 'rental_reservation_deleted',
  RENTAL_AGREEMENT_IN_PROGRESS = 'rental_agreement_in_progress',
  RENTAL_AGREEMENT_CANCELLED = 'rental_agreement_cancelled',
  RENTAL_AGREEMENT_DELETED = 'rental_agreement_deleted',
  VEHICLE_CREATED = 'vehicle_created',
  VEHICLE_SETTLED = 'vehicle_settled',
  VEHICLE_DELETED = 'vehicle_deleted',
  CUSTOMER_CREATED = 'customer_created',
  CUSTOMER_SETTLED = 'customer_settled',
  CUSTOMER_DELETED = 'customer_deleted',
  TRANSACTION_CREATED = 'transaction_created',
  TRANSACTION_SETTLED = 'transaction_settled',
  TRANSACTION_DELETED = 'transaction_deleted',
  LOCATION_CREATED = 'location_created',
  LOCATION_SETTLED = 'location_settled',
  LOCATION_DELETED = 'location_deleted',
  SUPPLIER_CREATED = 'supplier_created',
  SUPPLIER_SETTLED = 'supplier_settled',
  SUPPLIER_DELETED = 'supplier_deleted',
  AGENT_CREATED = 'agent_created',
  AGENT_SETTLED = 'agent_settled',
  AGENT_DELETED = 'agent_deleted',
  VEHICLE_DAMAGE_CREATED = 'vehicle_damage_created',
  VEHICLE_DAMAGE_SETTLED = 'vehicle_damage_settled',
  VEHICLE_DAMAGE_DELETED = 'vehicle_damage_deleted',
  VEHICLE_MAINTENANCE_CREATED = 'vehicle_maintenance_created',
  VEHICLE_MAINTENANCE_SETTLED = 'vehicle_maintenance_settled',
  VEHICLE_MAINTENANCE_DELETED = 'vehicle_maintenance_deleted',
  VEHICLE_ROAD_TAX_CREATED = 'vehicle_road_tax_created',
  VEHICLE_ROAD_TAX_SETTLED = 'vehicle_road_tax_settled',
  VEHICLE_ROAD_TAX_DELETED = 'vehicle_road_tax_deleted',
  VEHICLE_ROAD_WORTHY_CHECK_CREATED = 'vehicle_road_worthy_check_created',
  VEHICLE_ROAD_WORTHY_CHECK_SETTLED = 'vehicle_road_worthy_check_settled',
  VEHICLE_ROAD_WORTHY_CHECK_DELETED = 'vehicle_road_worthy_check_deleted',
  VEHICLE_INSURANCE_CREATED = 'vehicle_insurance_created',
  VEHICLE_INSURANCE_SETTLED = 'vehicle_insurance_settled',
  VEHICLE_INSURANCE_DELETED = 'vehicle_insurance_deleted',
  VEHICLE_INSURANCE_CLAIM_CREATED = 'vehicle_insurance_claim_created',
  VEHICLE_INSURANCE_CLAIM_SETTLED = 'vehicle_insurance_claim_settled',
  VEHICLE_INSURANCE_CLAIM_DELETED = 'vehicle_insurance_claim_deleted',
  AGENT_CATEGORY_CREATED = 'agent_category_created',
  AGENT_CATEGORY_DELETED = 'agent_category_deleted',
  VEHICLE_CATEGORY_CREATED = 'vehicle_category_created',
  VEHICLE_CATEGORY_DELETED = 'vehicle_category_deleted',

  // Addons
  ADDON_PDF_PRINT = 'addon_pdf_print',
  ADDON_E_SIGNATURE = 'addon_e_signature',
  ADDON_DATA_EXPORT = 'addon_data_export',

  // Storage
  STORAGE_BYTES = 'storage_bytes',
}
